import { Injectable, effect, inject } from '@angular/core';

import { ApiService } from './api.service';
import { Observable, map } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private apiService = inject(ApiService);
  private userService = inject(UserService);
  private cache = new Map<string, object | string | number | boolean>();

  constructor() {
    effect(() => {
      if (this.userService.isAuthenticated()) {
        this.load().subscribe();
      }
    });
  }

  public get(key: string): object | string | number | boolean | undefined {
    return this.cache.get(key);
  }

  public set(key: string, value: object | string | number | boolean, persist = false): void {
    this.cache.set(key, value);
    if (persist) {
      this.apiService.post<void>('/api/user/session', { key, value }).subscribe();
    }
  }

  public setAndWait(key: string, value: object | string | number | boolean): Observable<void> {
    this.cache.set(key, value);
    return this.apiService.post<void>('/api/user/session', { key, value });
  }


  public remove(key: string): boolean {
    return this.cache.delete(key);
  }

  public clear(persist = false): void {
    this.cache.clear();
    if (persist) {
      this.apiService.delete<void>('/api/user/session').subscribe();
    }
  }

  public load(): Observable<void> {
    return this.apiService.get<object>('/api/user/session')
      .pipe(map(data => {
        this.cache.clear();
        this.cache = new Map<string, object>(Object.entries(data));
      }));
  }

  public loadData(data: object) {
    this.cache.clear();
    this.cache = new Map<string, object>(Object.entries(data));
  }
}
